import { Link } from 'react-router-dom';

const SERVES = [
  'Pre-primary, primary, junior and senior school teachers',
  'STEM teacher trainers and master trainers',
  'Teacher training colleges and universities',
  'Head teachers, principals, deputies and heads of department',
  'Curriculum support officers',
  'Ministries of Education',
  'Education NGOs and development partners',
];

const SOLUTIONS = [
  {
    title: 'Professional Learning Academy',
    body: 'Continuous professional development for teachers, trainers and school leaders implementing Competency-Based Education.',
    to: '/academy',
  },
  {
    title: 'Teacher Resource Centre',
    body: 'Lesson plans, schemes of work, practical manuals, assessment banks and multimedia presentations.',
    to: '/academy',
  },
  {
    title: 'Student Learning Centre',
    body: 'Interactive lessons, practice questions, virtual experiments and career guidance aligned to African curricula.',
    to: '/academy',
  },
  {
    title: 'Virtual STEM Laboratory',
    body: 'Hands-on practical work that runs on any device — and asks the same questions on a feature phone as on a desktop.',
    to: '/laboratories',
  },
];

export function HomePage() {
  return (
    <>
      <section className="bg-gradient-to-b from-brand-900 to-brand-800 text-white">
        <div className="mx-auto max-w-7xl px-4 py-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-brand-200">
            VISINA Consult Limited
          </p>
          <h1 className="mt-2 max-w-3xl text-4xl font-bold leading-tight sm:text-5xl">
            Empowering STEM teachers, teacher trainers and school leaders across Africa
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-brand-100">
            Africa's digital platform for STEM professional learning, innovative teaching resources,
            virtual laboratories and collaborative communities supporting quality Competency-Based
            Education.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/login"
              className="btn bg-white px-6 text-brand-900 hover:bg-brand-50"
            >
              Create a free account
            </Link>
            <Link
              to="/laboratories"
              className="btn border border-white/40 px-6 text-white hover:bg-white/10"
            >
              See a virtual laboratory
            </Link>
          </div>

          {/*
            The specific promise, stated up front, because it is the thing that
            distinguishes this from every other LMS pitched at African schools:
            the assessment does not get easier when the connection does.
          */}
          <p className="mt-8 max-w-2xl rounded-xl bg-white/10 p-4 text-sm text-brand-50">
            <strong className="font-semibold">Works where your learners are.</strong> Our
            laboratories render from a single declarative script at four levels of detail — down to
            a text-only version that works on 2G and with a screen reader. The questions are
            identical at every level, so a learner on a feature phone is assessed on exactly the same
            work as one on a desktop.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14">
        <h2 className="text-2xl font-bold text-ink-900">Our digital solutions</h2>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SOLUTIONS.map(item => (
            <Link key={item.title} to={item.to} className="card transition-shadow hover:shadow-md">
              <h3 className="text-base font-semibold text-ink-900">{item.title}</h3>
              <p className="mt-1 text-sm text-ink-600">{item.body}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="border-y border-ink-200 bg-ink-50">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-14 lg:grid-cols-2">
          <div>
            <h2 className="text-2xl font-bold text-ink-900">Who we serve</h2>
            <ul className="mt-4 space-y-2 text-sm text-ink-700">
              {SERVES.map(item => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden="true" className="text-brand-700">
                    ▸
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-ink-900">Free, and premium</h2>
            <p className="mt-2 text-sm text-ink-600">
              Every account gets introductory STEM courses, CBE orientation modules, professional
              webinars, demonstration lessons and sample assessments. Premium membership adds
              certification courses, the full resource centre, the virtual laboratories and the
              analytics an institution needs.
            </p>
            <Link to="/membership" className="btn-primary mt-4">
              Compare membership
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
